module.exports = __webpack_public_path__ + "img/icono-notificacion-62.ede8066c.svg";